<script setup>
// ============================================================================
// BonBoZ: ĐƯỜNG NHỎ (sparkline) trong ô số của khối "Tương tác" — kiểu Pancake.
//
// Không trục, không lưới, không chú giải: nó không để đọc con số, chỉ để thấy
// HÌNH DẠNG — kỳ này đi lên, đi xuống hay giật cục. Con số đã nằm ngay trên nó.
//
// Vì thế cũng KHÔNG có tooltip: rê chuột vào một đường cao 40px để đọc số là
// thao tác không ai làm, mà bật lên thì che mất ô bên cạnh.
// ============================================================================
import { computed } from 'vue';
import { Chart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  LineElement,
  LineController,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from 'chart.js';
import { mauCss } from 'dashboard/helper/mauBieuDo';

const props = defineProps({
  so: { type: Array, default: () => [] },
  mau: { type: String, default: '--bonboz-mo' },
});

// Đăng ký ở thân module, cùng lý do đã ghi ở `BieuDoTron.vue`: component này
// chỉ mount khi dữ liệu ĐÃ có, không có lần dựng lại thứ hai để cứu.
ChartJS.register(
  LineElement,
  LineController,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

const duLieu = computed(() => ({
  labels: props.so.map((_, i) => i),
  datasets: [
    {
      data: props.so,
      borderColor: () => mauCss(props.mau),
      backgroundColor: () => mauCss(props.mau, 0.12),
      borderWidth: 1.5,
      pointRadius: 0,
      tension: 0.4,
      fill: true,
    },
  ],
}));

const tuyChon = {
  maintainAspectRatio: false,
  animation: false,
  plugins: { legend: { display: false }, tooltip: { enabled: false } },
  // Tắt cả hai trục và cắt sát mép: đường phải chiếm trọn ô, không chừa lề cho
  // nhãn mà ô này không có.
  scales: { x: { display: false }, y: { display: false } },
  layout: { padding: 0 },
  elements: { line: { capBezierPoints: false } },
};
</script>

<template>
  <Chart type="line" :data="duLieu" :options="tuyChon" />
</template>
